export default __webpack_public_path__ + "assets/ico_booking_you-52784e3b.svg";